module.exports = __webpack_public_path__ + "img/IMG_9519_L_WoodMatted.37a88fc5.jpg";